
import weconfig from '@/libs/config'

export default {
  state: {
    pageNum:weconfig.getPageNum(),
    app_id: weconfig.getAppId(),
    systemInfo:weconfig.getSystemInfo(),
  },
  mutations: {
      setSystemInfo(state, system){
          state.systemInfo = system;
          weconfig.setSystemInfo(system)
      },
      setAppId(state, app_id){
          state.app_id = app_id;
          weconfig.setAppId(app_id)
      },
      setPageNum(state, pageNum){
          state.pageNum = pageNum;
          weconfig.setPageNum(pageNum)
      },
  },
  getters: {
  },
  actions: {
  }
}
